<template>
  <div class="kt-configurator">
    <h1 class="kt-visually-hidden">
      Customize your {{ title }} {{ productType }}
    </h1>
    <transition name="fade">
      <div v-if="showColorPicker">
        <div v-if="pattern.colorCount">
          <!-- This is the modal -->
          <div uk-sticky style="background-color:white;">
            <div class="uk-flex uk-flex-center uk-margin-small-top">
              <div
                class="uk-inline uk-width-1-3@m uk-margin-small-bottom uk-margin-small-left uk-margin-small-right"
              >
                <button class="uk-button uk-button-default uk-width-1-1">
                  Filter <span class="uk-visible@s">Colors</span>
                </button>
                <div uk-dropdown="mode: click">
                  <div class="uk-inline uk-width-1-1">
                    <span
                      class="uk-form-icon"
                      uk-icon="icon: search"
                      aria-hidden="true"
                    ></span>
                    <input
                      v-model="colorSearch"
                      class="uk-input"
                      type="text"
                      aria-label="Search for a color"
                    />
                  </div>
                  <h4
                    v-if="
                      colorFamily ||
                        colorGroup ||
                        colorSearch ||
                        viewColorHistory
                    "
                    class="uk-margin-small-top"
                    @click="clearColorFilters()"
                  >
                    <a class="uk-link-reset" href="#">Remove Color Filters</a>
                  </h4>
                  <ul uk-accordion="duration:50; ">
                    <li>
                      <a class="uk-accordion-title" href="#"
                        >Filter Color Families</a
                      >
                      <div class="uk-accordion-content">
                        <ul class="uk-nav uk-dropdown-nav">
                          <li @click="colorFamily = 'Red'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Red'"
                                uk-icon="icon: check"
                              ></span
                              >Red</a
                            >
                          </li>
                          <li @click="colorFamily = 'Orange'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Orange'"
                                uk-icon="icon: check"
                              ></span
                              >Orange</a
                            >
                          </li>
                          <li @click="colorFamily = 'Yellow'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Yellow'"
                                uk-icon="icon: check"
                              ></span
                              >Yellow</a
                            >
                          </li>
                          <li @click="colorFamily = 'Green'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Green'"
                                uk-icon="icon: check"
                              ></span
                              >Green</a
                            >
                          </li>
                          <li @click="colorFamily = 'Blue'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Blue'"
                                uk-icon="icon: check"
                              ></span
                              >Blue</a
                            >
                          </li>
                          <li @click="colorFamily = 'Purple'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Purple'"
                                uk-icon="icon: check"
                              ></span
                              >Purple</a
                            >
                          </li>
                          <li @click="colorFamily = 'Pink'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Pink'"
                                uk-icon="icon: check"
                              ></span
                              >Pink</a
                            >
                          </li>
                          <li @click="colorFamily = 'White/Off White'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'White/Off White'"
                                uk-icon="icon: check"
                              ></span
                              >White/Off White</a
                            >
                          </li>
                          <li @click="colorFamily = 'Gray'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Gray'"
                                uk-icon="icon: check"
                              ></span
                              >Gray</a
                            >
                          </li>

                          <li v-if="colorFamily" @click="colorFamily = ''">
                            <a href="#">Clear Filter</a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <a class="uk-accordion-title" href="#"
                        >Filter Dress Makers</a
                      >
                      <div class="uk-accordion-content">
                        <ul class="uk-nav uk-dropdown-nav">
                          <li @click="colorGroup = 'Azazie'">
                            <a href="#"
                              ><span
                                v-if="colorGroup == 'Azazie'"
                                uk-icon="icon: check"
                              ></span
                              >Azazie</a
                            >
                          </li>
                          <li @click="colorGroup = 'Davids Bridal'">
                            <a href="#"
                              ><span
                                v-if="colorGroup == 'Davids Bridal'"
                                uk-icon="icon: check"
                              ></span
                              >David's Bridal</a
                            >
                          </li>
                          <li v-if="colorGroup" @click="colorGroup = ''">
                            <a href="#">Clear Filter</a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <a class="uk-accordion-title" href="#"
                        >Your Color History</a
                      >
                      <div class="uk-accordion-content">
                        <ul class="uk-nav uk-dropdown-nav">
                          <li @click="viewColorHistory = true">
                            <a href="#"
                              ><span
                                v-if="viewColorHistory"
                                uk-icon="icon: check"
                              ></span
                              >View Your Color History</a
                            >
                          </li>
                          <li @click="viewColorHistory = false">
                            <a href="#"
                              ><span
                                v-if="!viewColorHistory"
                                uk-icon="icon: check"
                              ></span
                              >View All Colors</a
                            >
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <button
                v-if="remainingToSelect > 0"
                class="uk-button uk-button-default uk-width-1-3@m uk-margin-small-bottom uk-margin-small-right"
                disabled
              >
                Select {{ remainingToSelect }}
                <span class="uk-visible@s"
                  >color<span v-if="remainingToSelect > 1">s</span></span
                >
              </button>
              <button
                v-if="remainingToSelect == 0"
                class="uk-button uk-button-primary uk-width-1-3@m uk-margin-small-bottom uk-margin-small-right"
                @click="closeColorPicker()"
              >
                Continue
              </button>
            </div>
            <div class="uk-container uk-visible@s">
              <div
                class="uk-margin-small-bottom uk-grid-small uk-container"
                style="margin-left: 0px;"
                uk-grid
              >
                <div
                  v-for="(color, index) in fullColors"
                  class="uk-card uk-card-body uk-card-default uk-card-small uk-margin-remove-top uk-margin-small-bottom uk-padding-small uk-width-1-1 uk-width-1-3@s uk-width-1-4@m"
                >
                  <span :style="{ color: color.hex }">◉</span>
                  {{ color.colorName }}
                  <a
                    uk-icon="close"
                    class="uk-float-right"
                    @click="removeColor(index)"
                  ></a>
                </div>
              </div>
            </div>
            <div class="uk-container uk-hidden@s">
              <ul uk-accordion="duration:50">
                <li>
                  <a class="uk-accordion-title" href="#"
                    >View Selected Colors</a
                  >
                  <div
                    class="uk-margin-small-bottom uk-grid-small uk-container uk-accordion-content"
                    style="margin-left: 0px;"
                    uk-grid
                  >
                    <div v-if="fullColors.length == 0">
                      <p>No colors selected</p>
                    </div>
                    <div
                      v-for="(color, index) in fullColors"
                      v-else
                      class="uk-card uk-card-body uk-card-default uk-card-small uk-margin-remove-top uk-margin-small-bottom uk-padding-small uk-width-1-1 uk-width-1-3@s uk-width-1-4@m"
                    >
                      <span :style="{ color: color.hex }">◉</span>
                      {{ color.colorName }}
                      <a
                        uk-icon="close"
                        class="uk-float-right"
                        @click="removeColor(index)"
                      ></a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="uk-container">
            <!-- NO QUERY PARAMS -->

            <hr class="uk-margin-remove-top" />
            <div
              class="uk-grid uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-6@m"
              uk-overflow-auto
            >
              <template v-if="!viewColorHistory">
                <div v-for="color in filteredColors">
                  <div
                    :class="{
                      'uk-box-shadow-xlarge': colorIsSelected(color)
                    }"
                    :aria-pressed="colorIsSelected(color) ? 'true' : 'false'"
                    class="uk-card uk-card-default uk-margin-small-bottom uk-card-hover uk-box-shadow-small kt-color-swatch"
                    role="button"
                    tabindex="0"
                    style="cursor: pointer"
                    @click="toggleColorSelectionOriginal(color)"
                    @keydown.enter.prevent="toggleColorSelectionOriginal(color)"
                    @keydown.space.prevent="toggleColorSelectionOriginal(color)"
                  >
                    <div
                      v-if="colorIsSelected(color)"
                      class="uk-card-badge uk-label uk-light uk-position-none uk-position-top-right uk-position-absolute"
                    >
                      <span uk-icon="icon: check"></span>
                    </div>
                    <svg
                      id="Layer_1"
                      class="uk-margin-remove"
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 100 50"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <rect
                        :style="{ fill: color.hex }"
                        width="100"
                        height="50"
                      />
                    </svg>
                    <div class="uk-padding-small">
                      {{ color.colorName }}<br />
                      <span
                        v-if="color.colorSet == 'Davids Bridal'"
                        class="uk-text-small"
                        >Matches David's Bridal</span
                      >
                      <span
                        v-if="color.colorSet == 'Azazie'"
                        class="uk-text-small"
                        >Matches Azazie</span
                      >
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="viewColorHistory">
                <div v-for="color in colorHistory">
                  <div
                    :class="{
                      'uk-box-shadow-xlarge': colorIsSelected(color)
                    }"
                    :aria-pressed="colorIsSelected(color) ? 'true' : 'false'"
                    class="uk-card uk-card-default uk-margin-small-bottom uk-card-hover uk-box-shadow-small kt-color-swatch"
                    role="button"
                    tabindex="0"
                    style="cursor: pointer"
                    @click="toggleColorSelection(color)"
                    @keydown.enter.prevent="toggleColorSelection(color)"
                    @keydown.space.prevent="toggleColorSelection(color)"
                  >
                    <svg
                      id="Layer_1"
                      class="uk-margin-remove"
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 100 50"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <rect
                        :style="{ fill: color.hex }"
                        width="100"
                        height="50"
                      />
                    </svg>
                    <div class="uk-padding-small">
                      {{ color.colorName }}
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-show="!showColorPicker">
        <div class="uk-grid-small uk-padding-small uk-background-muted" uk-grid>
          <div class="uk-width-1-2@m">
            <div class="uk-card uk-card-small uk-card-default ">
              <svgpreview :colors="colors" :svg="pattern.svg"></svgpreview>
            </div>
            <div
              class="uk-card uk-card-default uk-card-body uk-margin-small-top"
            >
              <button
                class="uk-button uk-button-primary uk-width-expand"
                @click="svgToBase64"
              >
                {{ ctaLabel }}
              </button>
            </div>
          </div>
          <div class="uk-width-1-2@m" uk-height-viewport="expand: true">
            <div
              id="colors-in-your-design"
              tabindex="-1"
              class="uk-card uk-card-default uk-card-body uk-margin-small-bottom"
            >
              <h2 class="uk-h3 uk-margin-small">Colors in Your Design</h2>
              <p class="uk-margin-small">
                Select color square you’d like to replace, then select new color
                from library below
              </p>
              <div
                class="uk-flex-between uk-flex-middle uk-margin-small"
                uk-grid
              >
                <div class="uk-width-auto">
                  <span uk-icon="move" aria-hidden="true"></span> Drag to
                  reorder
                </div>
                <div>
                  <button
                    class="uk-button uk-button-default"
                    @click="shuffleColors()"
                  >
                    Shuffle
                  </button>
                  <button
                    v-if="hasQueryParams"
                    class="uk-button uk-button-default"
                    @click="resetColors()"
                  >
                    Reset
                  </button>
                </div>
              </div>
              <draggable
                v-if="fullColors"
                v-model="fullColors"
                :options="{ animation: 300 }"
                class="grabbable uk-grid-small"
                style="margin: 0px"
                uk-grid
                @start="drag = true"
                @end="drag = false"
              >
                <div
                  v-for="(color, index) in fullColors"
                  :uk-tooltip="colorTooltip(color.colorName, color.colorSet)"
                  :key="color.id"
                  :aria-label="
                    'Design color ' +
                      (index + 1) +
                      ': ' +
                      colorAriaLabel(color) +
                      '. Select to replace it with a color from the library'
                  "
                  :aria-pressed="
                    activelySelectedColor(color, index) ? 'true' : 'false'
                  "
                  :class="{
                    'selected-color': activelySelectedColor(color, index)
                  }"
                  class="uk-padding-remove uk-width-1-6 uk-width-1-6@m kt-color-swatch"
                  role="button"
                  tabindex="0"
                  @click="selectColor(color, index)"
                  @touchend="selectColor(color, index)"
                  @keydown.enter.prevent="selectColor(color, index)"
                  @keydown.space.prevent="selectColor(color, index)"
                >
                  <svg
                    id="Layer_1"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 100 100"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <rect
                      :style="{
                        fill: fullColors[index].hex
                      }"
                      width="100"
                      height="100"
                    />
                  </svg>
                </div>
              </draggable>
              <div
                class="uk-grid-small uk-margin-medium uk-flex-between"
                uk-grid
              >
                <h2 class="uk-h3 uk-margin-none uk-width">Color Library</h2>
                <p class="uk-margin-small">
                  Type in search bar, use filters or scroll down to view 500+
                  colors
                </p>
                <div
                  class="uk-grid-small uk-width-2-3 uk-flex-between uk-position-relative"
                  uk-inline-grid
                >
                  <input
                    v-model="colorSearch"
                    class="uk-input kt-search"
                    type="text"
                    placeholder="Search for a color"
                    aria-label="Search for a color"
                  />
                  <span
                    class="uk-form-icon uk-position-right"
                    uk-icon="icon: search"
                    aria-hidden="true"
                  ></span>
                </div>
                <button class="uk-button uk-button-default uk-width-1-3">
                  Filter <span class="uk-visible@s">Colors</span>
                </button>
                <div uk-dropdown="mode: click">
                  <h4
                    v-if="
                      colorFamily ||
                        colorGroup ||
                        colorSearch ||
                        viewColorHistory
                    "
                    class="uk-margin-small-top"
                    @click="clearColorFilters()"
                  >
                    <a class="uk-link-reset" href="#">Remove Color Filters</a>
                  </h4>
                  <ul uk-accordion="duration:50; ">
                    <li>
                      <a class="uk-accordion-title" href="#"
                        >Filter Color Families</a
                      >
                      <div class="uk-accordion-content">
                        <ul class="uk-nav uk-dropdown-nav">
                          <li @click="colorFamily = 'Red'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Red'"
                                uk-icon="icon: check"
                              ></span
                              >Red</a
                            >
                          </li>
                          <li @click="colorFamily = 'Orange'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Orange'"
                                uk-icon="icon: check"
                              ></span
                              >Orange</a
                            >
                          </li>
                          <li @click="colorFamily = 'Yellow'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Yellow'"
                                uk-icon="icon: check"
                              ></span
                              >Yellow</a
                            >
                          </li>
                          <li @click="colorFamily = 'Green'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Green'"
                                uk-icon="icon: check"
                              ></span
                              >Green</a
                            >
                          </li>
                          <li @click="colorFamily = 'Blue'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Blue'"
                                uk-icon="icon: check"
                              ></span
                              >Blue</a
                            >
                          </li>
                          <li @click="colorFamily = 'Purple'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Purple'"
                                uk-icon="icon: check"
                              ></span
                              >Purple</a
                            >
                          </li>
                          <li @click="colorFamily = 'Pink'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Pink'"
                                uk-icon="icon: check"
                              ></span
                              >Pink</a
                            >
                          </li>
                          <li @click="colorFamily = 'White/Off White'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'White/Off White'"
                                uk-icon="icon: check"
                              ></span
                              >White/Off White</a
                            >
                          </li>
                          <li @click="colorFamily = 'Gray'">
                            <a href="#"
                              ><span
                                v-if="colorFamily == 'Gray'"
                                uk-icon="icon: check"
                              ></span
                              >Gray</a
                            >
                          </li>

                          <li v-if="colorFamily" @click="colorFamily = ''">
                            <a href="#">Clear Filter</a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <a class="uk-accordion-title" href="#"
                        >Filter Dress Makers</a
                      >
                      <div class="uk-accordion-content">
                        <ul class="uk-nav uk-dropdown-nav">
                          <li @click="colorGroup = 'Azazie'">
                            <a href="#"
                              ><span
                                v-if="colorGroup == 'Azazie'"
                                uk-icon="icon: check"
                              ></span
                              >Azazie</a
                            >
                          </li>
                          <li @click="colorGroup = 'Davids Bridal'">
                            <a href="#"
                              ><span
                                v-if="colorGroup == 'Davids Bridal'"
                                uk-icon="icon: check"
                              ></span
                              >David's Bridal</a
                            >
                          </li>
                          <li v-if="colorGroup" @click="colorGroup = ''">
                            <a href="#">Clear Filter</a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <a class="uk-accordion-title" href="#"
                        >Your Color History</a
                      >
                      <div class="uk-accordion-content">
                        <ul class="uk-nav uk-dropdown-nav">
                          <li @click="viewColorHistory = true">
                            <a href="#"
                              ><span
                                v-if="viewColorHistory"
                                uk-icon="icon: check"
                              ></span
                              >View Your Color History</a
                            >
                          </li>
                          <li @click="viewColorHistory = false">
                            <a href="#"
                              ><span
                                v-if="!viewColorHistory"
                                uk-icon="icon: check"
                              ></span
                              >View All Colors</a
                            >
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                class="uk-grid-small uk-height-max-medium uk-overflow-auto"
                uk-grid
              >
                <template v-if="!viewColorHistory">
                  <div v-for="color in filteredColors" class="uk-width-1-8">
                    <div
                      :uk-tooltip="
                        colorTooltip(color.colorName, color.colorSet)
                      "
                      :class="{
                        'uk-box-shadow-xlarge': colorIsSelected(color)
                      }"
                      :aria-label="colorAriaLabel(color)"
                      :aria-pressed="colorIsSelected(color) ? 'true' : 'false'"
                      class="uk-card uk-card-default uk-card-hover kt-color-swatch"
                      role="button"
                      tabindex="0"
                      style="cursor: pointer"
                      @click="toggleColorSelection(color)"
                      @keydown.enter.prevent="toggleColorSelection(color)"
                      @keydown.space.prevent="toggleColorSelection(color)"
                    >
                      <svg
                        id="Layer_1"
                        class="uk-margin-remove"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 100 100"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <rect
                          :style="{ fill: color.hex }"
                          width="100"
                          height="100"
                        />
                      </svg>
                    </div>
                  </div>
                </template>
              </div>
              <h2 class="uk-h3">Color History</h2>
              <div
                class="uk-grid-small uk-height-max-medium uk-overflow-auto"
                uk-grid
              >
                <div
                  v-for="color in colorHistory.slice(0, 16)"
                  class="uk-width-1-8"
                >
                  <div
                    :uk-tooltip="colorTooltip(color.colorName, color.colorSet)"
                    :class="{
                      'uk-box-shadow-xlarge': colorIsSelected(color)
                    }"
                    :aria-label="colorAriaLabel(color)"
                    :aria-pressed="colorIsSelected(color) ? 'true' : 'false'"
                    class="uk-card uk-card-default uk-card-hover kt-color-swatch"
                    role="button"
                    tabindex="0"
                    style="cursor: pointer"
                    @click="toggleColorSelection(color)"
                    @keydown.enter.prevent="toggleColorSelection(color)"
                    @keydown.space.prevent="toggleColorSelection(color)"
                  >
                    <svg
                      id="Layer_1"
                      class="uk-margin-remove"
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 100 100"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <rect
                        :style="{ fill: color.hex }"
                        width="100"
                        height="100"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="uk-card  uk-card-default uk-card-body uk-margin-small-bottom"
            >
              <h2 class="uk-h3">Design Tips</h2>
              <p>
                <a
                  class="kt-cta-link"
                  href="https://www.knottytie.com/products/colormatch-chart"
                  target="_blank"
                  >Check out a ColorMatch Chart</a
                >
                before you order your custom
                {{ productType }} so you can see how the colors look in real
                life. Colors may vary from screen to print, but your colors are
                guaranteed to match the ColorMatch chart.
              </p>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div id="creating-product" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-margin-auto-vertical uk-padding-large">
        <center>
          <h4 class="uk-align-center">
            Hold tight, we're creating your product.
          </h4>
          <h4 class="uk-align-center">
            Most designs take 30 seconds or less but creation can take up to 2
            minutes.
          </h4>
          <span
            class="uk-margin-small-right uk-align-center"
            uk-spinner="ratio: 3"
          ></span>
        </center>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ProductsService from "@/services/ProductsService";
import UIkit from "uikit";
import firebase from "firebase";
import ProjectsService from "@/services/ProjectsService";
import { resolveProductType } from "@/utils/productTypes";

export default {
  name: "Configurator",
  components: { draggable },
  data() {
    return {
      fullColors: [],
      id: this.$route.params.id,
      description: "",
      productLink: "",
      base64Img: "",
      serialized: "",
      svg: "",
      allColors: [],
      colorGroup: "",
      colorFamily: "",
      colorSearch: "",
      pattern: {},
      viewColorHistory: false,
      colorHistory: [],
      showColorPicker: true,
      selectedColor: {},
      selectedColors: [],
      hasQueryParams: false,
      sampleProductData: null,
      ctaLabel: "Create My Product"
    };
  },
  computed: {
    filteredColors() {
      var self = this;
      return self.allColors.filter(function(color) {
        if (
          color.colorSet.includes(self.colorGroup) ||
          color.category.includes(self.colorFamily)
        ) {
          return (
            color.colorSet.includes(self.colorGroup) &&
            color.category.includes(self.colorFamily) &&
            color.colorName
              .toLowerCase()
              .includes(self.colorSearch.toLowerCase())
          );
        } else {
          return color.colorName
            .toLowerCase()
            .includes(self.colorSearch.toLowerCase());
        }
      });
    },
    colors() {
      var self = this;
      var array = [];
      for (var i = self.fullColors.length - 1; i >= 0; i--) {
        array.push(self.fullColors[i].hex);
      }
      return array;
    },
    remainingToSelect() {
      return this.pattern.colorCount - this.fullColors.length;
    },
    productType() {
      var self = this;
      return self.checkType();
    },
    title() {
      return this.id.replace(/-/g, " ").replace(" " + this.productType, "");
    }
  },
  watch: {
    pattern: function() {
      setTimeout(() => {
        UIkit.modal("#colorPicker").show();
      }, 1000);
    },
    serialized: function() {
      this.addProduct();
    },
    productLink: function() {
      setTimeout(() => {
        window.location.href = this.productLink;
      }, 2000);
    }
  },
  async mounted() {
    await this.getPatternInfo();
    await this.getColorHistory();
    await this.getContentfulProductData();
    //this.fbTrackPageView();
    var self = this;
    const colorsRef = firebase
      .firestore()
      .collection("colors")
      .doc("0");
    colorsRef
      .get()
      .then(async function(doc) {
        if (doc.exists) {
          let c = doc.data();
          const knottyColors = c["knotty-colors"];
          self.allColors = knottyColors;
          await self.getParamColors();
        } else {
          // doc.data() will be undefined in this case
          console.warn("No such document!");
        }
      })
      .catch(function(error) {
        console.error("Error getting document:", error);
      });
  },
  methods: {
    colorTooltip(color, set) {
      if (["Azazie", "Davids Bridal"].includes(set)) {
        return `title: <div style="text-align: center"><span style="font-size: 16px">${color}</span><br />Matches ${set.replace(
          "Davids",
          "David's"
        )}</div>`;
      }
      return `title: <span style="font-size: 16px">${color}</span>`;
    },
    colorAriaLabel(color) {
      if (["Azazie", "Davids Bridal"].includes(color.colorSet)) {
        return `${color.colorName}, matches ${color.colorSet.replace(
          "Davids",
          "David's"
        )}`;
      }
      return color.colorName;
    },
    selectColor(color, index) {
      if (this.selectedColor == color) {
        this.selectedColor = {};
      } else {
        this.selectedColor = { color, index };
      }
      return this.selectedColor;
    },
    async getPatternInfo() {
      var response = await ProductsService.getProductByName({
        id: this.id
      });
      this.pattern = response.data;
    },
    checkType() {
      return resolveProductType(this.id);
    },
    async getParamColors() {
      const self = this;
      if (Object.keys(this.$route.query).length > 0) {
        this.hasQueryParams = true;
        this.pattern.colorCount = 0;
        for (var i = 0; i < Object.keys(this.$route.query).length; i++) {
          if (Object.entries(this.$route.query)[i][0].includes("color")) {
            for (var j = self.allColors.length - 1; j >= 0; j--) {
              if (
                self.allColors[j].hex ==
                "#" + Object.values(this.$route.query)[i]
              ) {
                this.pattern.colorCount++;
                self.fullColors.push(self.allColors[j]);
                self.toggleColorSelection(self.allColors[j], true);
                break;
              }
            }
            self.closeColorPicker();
          }
        }
      }
    },
    svgToBase64() {
      UIkit.modal("#creating-product").show();
      this.serialized = new XMLSerializer().serializeToString(
        document.getElementById("svgPreview")
      );
      var encodedData = window.btoa(this.serialized);
      this.base64Img = encodedData;
    },
    async addProduct() {
      var response = await ProductsService.addProductv2({
        handle: this.id,
        serialized: this.serialized,
        colors: this.fullColors
      });
      this.productLink = `https://www.knottytie.com/products/${this.id}?configuredId=${response.data.id}`;
    },
    clearColorFilters() {
      this.colorFamily = "";
      this.colorGroup = "";
      this.colorSearch = "";
      this.viewColorHistory = false;
    },
    removeColor(index) {
      this.fullColors.splice(index, 1);
    },
    activelySelectedColor(color, index) {
      return (
        this.selectedColor.color == color && this.selectedColor.index == index
      );
    },
    colorIsSelected(colorObject) {
      var self = this;
      for (var i = self.fullColors.length - 1; i >= 0; i--) {
        if (colorObject === self.fullColors[i]) {
          return true;
        }
      }
      return false;
    },
    async toggleColorSelectionOriginal(colorObject) {
      var self = this;
      var selected = false;
      var colorIndex = 0;
      for (var i = self.fullColors.length - 1; i >= 0; i--) {
        if (colorObject === self.fullColors[i]) {
          selected = true;
          colorIndex = i;
        }
      }
      if (selected == false) {
        if (this.pattern.colorCount === undefined) {
          this.pattern.colorCount = 0;
        }
        if (this.pattern.colorCount > self.fullColors.length) {
          self.fullColors.push(colorObject);
        } else {
          UIkit.notification(
            "Too many colors. Try removing a color before you add another.",
            { status: "warning" }
          );
        }
      } else {
        self.fullColors.splice(colorIndex, 1);
      }
    },
    async toggleColorSelection(colorObject, initialLoad) {
      var self = this;
      if (!this.selectedColor.color && !initialLoad) {
        UIkit.notification(
          "Please select a color above to switch to this color.",
          { status: "warning" }
        );
      } else {
        // If there's a selected color, take it - if not, it'll be -1
        const selectedIndex = self.selectedColor.index
          ? self.selectedColor.index
          : self.fullColors.indexOf(self.selectedColor.color);
        if (initialLoad) {
          // Reset selected color
          self.selectedColor = {};
        } else {
          // Replace color if not on initial load
          self.fullColors.splice(selectedIndex, 1, colorObject);
          self.selectedColor = {};
        }
        this.addSelectedColorToHistory(colorObject);
      }
    },
    addSelectedColorToHistory(color) {
      let previousColors = JSON.parse(
        localStorage.getItem("colorHistory") || "[]"
      );
      previousColors.push(color);
      localStorage.setItem("colorHistory", JSON.stringify(previousColors));
      this.getColorHistory();
    },
    resetColors() {
      var self = this;
      self.fullColors = [];
      this.getParamColors();
    },
    shuffleColors() {
      var self = this;
      var array = self.fullColors;

      function shuffle() {
        var i = 0,
          j = 0,
          temp = null;

        for (i = array.length - 1; i > 0; i -= 1) {
          j = Math.floor(Math.random() * (i + 1));
          temp = array[i];
          array[i] = array[j];
          array[j] = temp;
        }
      }
      shuffle();
      self.fullColors = [];
      for (var i = array.length - 1; i >= 0; i--) {
        self.fullColors.push(array[i]);
      }
      this.selectedColor = {};
    },
    closeColorPicker() {
      this.showColorPicker = false;
      this.addColorsToHistory();
    },
    addColorsToHistory() {
      var self = this;
      var existingHistory = JSON.parse(localStorage.getItem("colorHistory"));
      if (!existingHistory) {
        localStorage.setItem("colorHistory", JSON.stringify(self.fullColors));
      } else {
        const arrayUnique = function(array) {
          var a = array.concat();
          for (var i = 0; i < a.length; ++i) {
            for (var j = i + 1; j < a.length; ++j) {
              if (a[i].hex === a[j].hex) a.splice(j--, 1);
            }
          }

          return a;
        };
        var concatArray = arrayUnique(existingHistory.concat(self.fullColors));
        localStorage.setItem("colorHistory", JSON.stringify(concatArray));
      }
    },
    getColorHistory() {
      var self = this;
      if (localStorage.getItem("colorHistory")) {
        var history = JSON.parse(localStorage.getItem("colorHistory"));
        self.colorHistory = [];
        for (var i = history.length - 1; i >= 0; i--) {
          self.colorHistory.push(history[i]);
        }
      }
    },
    fbTrackPageView() {
      var self = this;
      window.fbq("track", "ViewContent", {
        content_ids: self.id
      });
    },
    async getContentfulProductData() {
      var self = this;
      const type = self.checkType();
      const query = `{
        portalProductCollection {
          items {
            productType
            sampleProduct
          }
        }
      }`;
      const fetchUrl = `https://graphql.contentful.com/content/v1/spaces/${process.env.CONTENTFUL_SPACE_ID}`;
      const fetchOptions = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${process.env.CONTENTFUL_ACCESS_TOKEN}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          query
        })
      };
      try {
        const response = await fetch(fetchUrl, fetchOptions).then(response =>
          response.json()
        );
        const productData = response.data.portalProductCollection.items;

        for (const product of productData) {
          if (product.productType.toLowerCase() == type) {
            const shopifyData = await ProjectsService.getProductById({
              id: product.sampleProduct
            }).then(response => {
              return response;
            });

            self.sampleProductData = shopifyData.data;
          }
        }
      } catch (error) {
        console.error(error);
        throw new Error("Could not receive the data from Contentful!");
      }
    }
  }
};
</script>

<style type="text/css">
.kt-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.kt-color-swatch:focus-visible {
  outline: 3px solid #1e87f0;
  outline-offset: 2px;
}

#colors-in-your-design:focus {
  outline: none;
}

.grabbable {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
  display: flex;
}

.grabbable > div {
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.15);
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.grabbable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Configurator.vue